import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _LightTheme5_;
import { createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicThemeClassForExtension } from "../BasicTheme";
import { LightTheme5_1 } from "../LightTheme5_1";
export var LightTheme5_2 = createTheme({
  themeClass: (_LightTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function LightTheme5_2() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(LightTheme5_2, _BasicThemeClassForEx);
    return _createClass(LightTheme5_2, null, [{
      key: "mobileModalCloseButtonRightPadding",
      get: function get() {
        return this.mobileModalCloseButtonClickArea;
      }
    }, {
      key: "mobileModalCloseButtonTopPadding",
      get: function get() {
        return this.mobileModalCloseButtonClickArea;
      }
    }]);
  }(BasicThemeClassForExtension), _LightTheme5_.mobileModalCloseButtonClickArea = '22px', _LightTheme5_.mobileModalBodyPadding = '0 16px 0 16px', _LightTheme5_.mobileModalContainerMarginTop = '16px', _LightTheme5_.mobileModalContainerMarginRight = '16px', _LightTheme5_.mobileModalContainerMarginBottom = '16px', _LightTheme5_.mobileModalContainerMarginLeft = '16px', _LightTheme5_.miniModalMarginTopMobile = '16px', _LightTheme5_.miniModalMarginLeftMobile = '16px', _LightTheme5_.miniModalMarginRightMobile = '16px', _LightTheme5_),
  prototypeTheme: LightTheme5_1,
  themeMarkers: [markThemeVersion('5.2')]
});